export default __webpack_public_path__ + "static/topic1-f8c752f8bd6ac83c2d7ddef13768da40.png";